import React from 'react';
import ServiceUnderConstruction from '../../components/ServiceUnderConstruction';
import logo from '../../assets/images/services/htla.webp';

const HTLA = () => {
    return (
        <ServiceUnderConstruction
            serviceKey="htla"
            logo={logo}
            primaryColor="#8B4513"
            secondaryColor="#D2691E"
        />
    );
};

export default HTLA;
